
import React, { useState, useMemo, useEffect } from 'react';
import { Formik, Form, Field, ErrorMessage } from 'formik';
import * as Yup from 'yup';
import styled from 'styled-components';
import { show_toast } from 'utils/helpers';
import TableComponent from 'components/widgets/table';
import { useQuery } from 'react-query';
import { list_my_products, list_cover_types, FetchInsuranceClasses,list_undewriter_products, fetch_product_details } from "services/apiSrv";


// Styled components (self-contained)
const Container = styled.div`
  background: #fff;
  padding: 20px;
  border-radius: 12px;
`;

const StepperNav = styled.div`
  display: flex;
  gap: 8px;
  margin-bottom: 16px;
  align-items: center;
`;

const Step = styled.button`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 6px 10px;
  border-radius: 8px;
  background: ${(p) => (p.active ? '#2563eb' : 'transparent')};
  color: ${(p) => (p.active ? '#fff' : '#374151')};
  cursor: pointer;
  border: none;

  .step-number {
    width: 28px;
    height: 28px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    background: ${(p) => (p.active ? '#fff' : p.completed ? '#2563eb' : '#e6eefc')};
    color: ${(p) => (p.active ? '#2563eb' : p.completed ? '#fff' : '#1f2937')};
    font-weight: 600;
    font-size: 13px;
    border: ${(p) => (p.completed && !p.active ? '2px solid #2563eb' : 'none')};
  }

  .step-label {
    font-size: 13px;
    font-weight: 500;
    color: ${(p) => (p.active ? '#fff' : '#374151')};
  }
`;

const Connector = styled.div`
  flex: 1 1 auto;
  height: 2px;
  background: ${(p) => (p.completed ? '#2563eb' : '#e6eefc')};
  border-radius: 2px;
  margin: 0 6px;
`;

const CardGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 16px;
  margin-bottom: 16px;

  @media (max-width: 800px) {
    grid-template-columns: 1fr;
  }
`;

const BigGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 16px;
  margin-bottom: 16px;

  @media (max-width: 1000px) {
    grid-template-columns: 1fr;
  }
`;

const Card = styled.div`
  background: #fbfdff;
  border: 1px solid #e6eefc;
  padding: 16px;
  border-radius: 10px;
`;

const SectionTitle = styled.h5`
  margin: 0 0 12px 0;
  font-size: 14px;
  color: #0f172a;
`;

const FieldRow = styled.div`
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
`;

const SmallField = styled.div`
  flex: 1 1 45%;
`;

const FullWidth = styled.div`
  width: 100%;
`;

const ProductCard = styled.button`
  display: flex;
  flex-direction: column;
  gap: 8px;
  align-items: flex-start;
  padding: 12px;
  border-radius: 8px;
  border: 1px solid ${(p) => (p.selected ? '#2563eb' : '#e6eefc')};
  background: ${(p) => (p.selected ? 'linear-gradient(135deg, #eef2ff, #e0e7ff)' : '#fff')};
  color: #0f172a;
  cursor: pointer;
  width: 100%;
  text-align: left;
  box-shadow: ${(p) => (p.selected ? '0 6px 18px rgba(37,99,235,0.08)' : 'none')};
  transition: transform 120ms ease, box-shadow 120ms ease;
  &:hover { transform: translateY(-2px); }
`;

const ProductGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 12px;
  margin-top: 8px;
  @media (max-width: 900px) { grid-template-columns: 1fr; }
`;

export default function Add_Portfolio({ onSubmit, onHide, fetchPortfolios = () => {} }) {
  const [loading, setLoading] = useState(false);
  const [currentStep, setCurrentStep] = useState(0);

  const [selectedType, setSelectedType] = useState('');
  const [selectedProduct, setSelectedProduct]= useState(null)
  const [selectedClass, setSelectedClass]= useState(null)
  const [coverProducts, setCoverProducts] = useState(null)

  const insuranceClasses = [
  { id: 1,  name: "Aviatoun" },
  { id: 2,  name: "Engineering" },
  { id: 3,  name: "Fire Domestic" },
  { id: 4,  name: "Fire Industrial" },
  { id: 5,  name: "Liability" },
  { id: 6,  name: "Marine" },
  { id: 7,  name: "Motor private" },
  { id: 8,  name: "Motor Commercial" },
  { id: 9,  name: "Personal Accident" },
  { id: 10, name: "Theft" },
  { id: 11, name: "Workmen's compensation" },
  { id: 12, name: "Medical" },
  { id: 13, name: "Micro-insurance" },
  { id: 14, name: "Miscellaneous" }
];

  let excessConfig;

    const { data: productData, isLoading, isSuccess, isError, error, refetch } = useQuery({
      queryKey: ['productDetails', selectedProduct?.productSystemRef],
      queryFn: () => fetch_product_details(selectedProduct?.productSystemRef),
      enabled: !!selectedProduct?.productSystemRef,
      retry: 2,
      staleTime: 5 * 60 * 1000,
      onSuccess: (data) => {
        console.log("data excesss===", data)
        excessConfig = data
      },
    });
  
     console.log("product data detail0s--0", productData)
  
    console.log("product data detail0s", productData?.data?.[0]?.productCover?.supportedPeriods)


      // Fetch products
      const { data: productList, isLoading: isLoadingProducts, error: productError } = useQuery({
        queryKey: ['products'],
        queryFn: list_my_products,
      });
    
      // Fetch cover types
      console.log("myproducts", productList)
    
    
      // Fetch subclasses
      const { data: subclasses = [], isLoading: isSubclasses, error: subclassError } = useQuery({
        queryKey:["classes"],
        queryFn:FetchInsuranceClasses
      });
       
      console.log("subclasses==", subclasses)


    const selectClass = useMemo(() => {
          console.log("sira", selectedProduct?.ira_code)
              console.log("sbc", subclasses?.data)
        if (!selectedProduct?.ira_code || !subclasses?.data) return null;
        return subclasses.data.find(cls => cls.ira_code === selectedProduct.ira_code);
      }, [selectedProduct?.ira_code, subclasses?.data]);
      
      const selectedClassSystemRef = selectClass?.ira_code;
      
          useEffect(() => {
            console.log("subclasses", subclasses)
            console.log("Selected Class:", selectClass);
            console.log("Class System Ref:", selectedClassSystemRef);
          }, [selectedClass, selectedClassSystemRef, selectedProduct?.ira_code]);
      
          const { 
            data: underwriterProductList, 
            isLoading: isProductUnderwriterLoading 
          } = useQuery({
            queryKey: ['underwriter_products', selectedClassSystemRef],
            queryFn: () => list_undewriter_products(selectedClassSystemRef),
            enabled: !!selectedClassSystemRef,
            retry: 1,
          });
          console.log("U-P-S", underwriterProductList)

              const allAvailableProducts = useMemo(() => {
              const underwriterProducts = underwriterProductList?.data || [];
              const genericProducts = productList?.data?._value || [];
          
              return  [...underwriterProducts, ...genericProducts]
            }, [underwriterProductList, productList]);
          
            console.log("selected products09====", selectedProduct)

const handleCoverSelect=(value) =>{
  const products= allAvailableProducts.filter((product)=>product.covertypeSystemRef== value)
  setCoverProducts(products)
}

  const coverTypeOptions = [
    { value: 'comprehensive', label: 'Comprehensive' },
    { value: 'third_party', label: 'Third Party' },
    { value: 'third_party_fire_theft', label: 'Third Party Fire & Theft' },
  ];

  const currencyOptions = [
    { value: 'KES', label: 'KES' },
  ];

  const validationSchema = Yup.object().shape({
    productName: Yup.string().required('Product is required'),
    Underwriter: Yup.string().required('Underwriter is required'),
    insuranceClass: Yup.string().required('Insurance class is required'),
    startDate: Yup.date().required('Start date is required'),
    endDate: Yup.date()
      .required('End date is required')
      .min(Yup.ref('startDate'), 'End date must be after start date'),
    CoverType: Yup.string().required('Cover type is required'),
    policyNumber: Yup.string().required('Policy number is required'),
    firstName: Yup.string().required('First name is required'),
    lastName: Yup.string().required('Last name is required'),
    middleName: Yup.string().optional(),
    phone: Yup.string()
      .required('Phone number is required')
      .matches(/^(?:\+254|0)([17]\d{8})$/, 'Invalid Kenyan phone (e.g. 0712345678 or +2547...)'),
    kraPin: Yup.string()
      .required('KRA PIN is required')
      .matches(/^[A-Z]\d{9}[A-Z]$/, 'Invalid format (e.g. A012345678Z)'),
    email: Yup.string().email('Invalid email').required('Email is required'),
    basePremium: Yup.number().required('Base premium required').min(0, 'Must be >= 0'),
    additionalPremium: Yup.number().min(0, 'Must be >= 0').optional(),
    commisionEarned: Yup.number().min(0, 'Must be >= 0').optional(),
    totalDiscount: Yup.number().min(0, 'Must be >= 0').optional(),
    policyCurrency: Yup.string().required().oneOf(['KES'], 'Must be KES for Kenyan policies'),
    totalCharges: Yup.number().required().min(0),
    riskValue: Yup.number().required('Vehicle value required').min(1),
    riskRef: Yup.string().required('Registration / Ref required'),
    riskchassisNumber: Yup.string().required('Chassis number required'),
    riskMake: Yup.string().required('Make required'),
    riskModel: Yup.string().required('Model required'),
    internalRef: Yup.string().optional(),
    remarks: Yup.string().max(1000, 'Remarks too long').optional(),
  });

  const handleSubmit = async (values, { resetForm }) => {
    setLoading(true);
    try {
      const payload = {
        CoverType: values.CoverType,
        Underwriter: values.Underwriter,
        insuranceClass: values.insuranceClass,
        startDate: values.startDate,
        endDate: values.endDate,
        policyNumber: values.policyNumber,
        basePremium: values.basePremium,
        additionalPremium: values.additionalPremium || 0,
        totalCharges: values.totalCharges,
        totalDiscount: values.totalDiscount || 0,
        email: values.email,
        phone: values.phone,
        kraPin: values.kraPin,
        firstName: values.firstName,
        lastName: values.lastName,
        middleName: values.middleName || '',
        riskValue: values.riskValue,
        riskRef: values.riskRef,
        riskchassisNumber: values.riskchassisNumber,
        riskMake: values.riskMake,
        riskModel: values.riskModel,
        policyCurrency: values.policyCurrency,
        commisionEarned: values.commisionEarned || 0,
        productName: values.productName,
        internalRef: values.internalRef || '',
        remarks: values.remarks || '',
      };
      console.log('Submitted Portfolio:', payload);
      show_toast('Portfolio added successfully', 'success');
      fetchPortfolios();
      onSubmit?.(payload);
      onHide?.();
      resetForm();
      setCurrentStep(0);
    } catch (err) {
      console.error(err);
      show_toast('Failed to add portfolio', 'error');
    } finally {
      setLoading(false);
    }
  };

  const steps = ['Product', 'Underwriter & Cover', 'Client', 'Vehicle & Premium'];

  const stepFieldMap = [
    ['productName'],
    ['Underwriter', 'insuranceClass', 'startDate', 'endDate', 'CoverType', 'policyNumber'],
    ['firstName', 'lastName', 'middleName', 'phone', 'kraPin', 'email'],
    ['riskValue', 'riskRef', 'riskchassisNumber', 'riskMake', 'riskModel', 'basePremium', 'additionalPremium', 'commisionEarned', 'totalDiscount', 'totalCharges'],
  ];

  return (
    <Container>
      <Formik
        initialValues={{
        productName: Yup.string().when('productType', {
            is: 'existing',
            then: (schema) => schema.required('Product is required'),
            otherwise: (schema) => schema.notRequired(),
          }),
          productType: '',
          Underwriter: '',
          insuranceClass: '',
          startDate: '',
          endDate: '',
          CoverType: '',
          policyNumber: '',
          firstName: '',
          lastName: '',
          middleName: '',
          phone: '',
          kraPin: '',
          email: '',
          basePremium: '',
          additionalPremium: '0',
          commisionEarned: '0',
          totalDiscount: '0',
          policyCurrency: 'KES',
          totalCharges: '',
          riskValue: '',
          riskRef: '',
          riskchassisNumber: '',
          riskMake: '',
          riskModel: '',
          internalRef: '',
          remarks: '',
        }}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
      >
        {({ values, setFieldValue, validateForm, setTouched }) => {
          const handleNext = async () => {
            const errors = await validateForm();
            const fields = stepFieldMap[currentStep] || [];
            setTouched(fields.reduce((acc, f) => ({ ...acc, [f]: true }), {}));
            if (!fields.some(f => errors[f])) {
              setCurrentStep(s => Math.min(s + 1, steps.length - 1));
            }
          };

          return (
            <Form>
              <StepperNav>
                {steps.map((s, i) => {
                  const completed = i < currentStep;
                  const active = i === currentStep;
                  return (
                    <React.Fragment key={s}>
                      <Step
                        type="button"
                        active={active}
                        completed={completed}
                        onClick={() => { if (i <= currentStep) setCurrentStep(i); }}
                        aria-current={active ? 'step' : undefined}
                      >
                        <span className="step-number">{i + 1}</span>
                        <span className="step-label">{s}</span>
                      </Step>
                      {i !== steps.length - 1 && <Connector completed={completed} />}
                    </React.Fragment>
                  );
                })}
              </StepperNav>

              {/* Step 1: Product */}
              {currentStep === 0 && (
                <>
                  <Card style={{ marginTop: 12 }}>
                    <h5 style={{ margin: 0 }}>Product Type</h5>
                    <p style={{ margin: '6px 0 0 0', color: '#6b7280', fontSize: 13 }}>
                      Choose whether this portfolio uses an existing product or a custom/non-catalog product.
                    </p>

                    <ProductGrid>
                      <ProductCard
                        type="button"
                        selected={values.productType === 'existing'}
                        onClick={() => {
                          setFieldValue('productType', 'existing');
                          setFieldValue('productName', '');           // reset if switching
                        }}
                      >
                        <strong>Existing Product</strong>
                        <div className="text-muted small">Select from catalog</div>
                      </ProductCard>

                      <ProductCard
                        type="button"
                        selected={values.productType === 'non-existing'}
                        onClick={() => {
                          setFieldValue('productType', 'non-existing');
                          setFieldValue('productName', '');           // reset if switching
                        }}
                      >
                        <strong>Non-existing / Custom Product</strong>
                        <div className="text-muted small">Enter product name manually</div>
                      </ProductCard>
                    </ProductGrid>
                  </Card>
                {values.productType === 'existing' && (<Card>
                <label className="form-label form-label-sm">Insurance Class / Subclass</label>
                <Field
                  as="select"
                  name="insuranceClass"
                  className="form-control form-control-sm"
                  onChange={(e) => {
                    const value = e.target.value;

                  const selectedProduct = subclasses?.data?.find(
                    (cls) => cls.ira_code === value
                  );
                  
                  setSelectedProduct(selectedProduct)

                  // const selectedClass = subclasses?.data

                    setFieldValue('insuranceClass', value);
                    // Reset downstream fields when class changes
                    setFieldValue('productName', '');
                    setFieldValue('Underwriter', '');
                    setSelectedClass(value);
                  }}
                >
                  <option value="">Select class...</option>
                  {subclasses?.data?.length > 0 ? (
                    subclasses.data
                      .sort((a, b) => a?.name?.localeCompare(b.name))
                      .map((cls) => (
                        <option key={cls.ira_code} value={cls.ira_code}>
                          {cls.name} ({cls.ira_code})
                        </option>
                      ))
                  ) : (
                    <option value="" disabled>
                      {isSubclasses ? 'Loading classes...' : 'No classes available'}
                    </option>
                  )}
                </Field>
                <ErrorMessage name="insuranceClass" component="div" className="text-danger small mt-1" />

                <Field
                  as="select"
                  name="coverType"
                  className="form-control form-control-sm"
                  onChange={(e) => {
                    const value = e.target.value;
                    setFieldValue('coverType', value);
                    handleCoverSelect(value)
                    // setFieldValue('insuranceClass', value);
                    // Reset downstream fields when class changes
                    // setFieldValue('productName', '');
                    // setFieldValue('Underwriter', '');
                    // setSelectedClass(value);
                  }}
                >
                  <option value="">Select Cover Type...</option>
                     {selectedProduct?.insurancecovertypes?.length > 0 ? (
                        selectedProduct?.insurancecovertypes?.map(option => (
                          <option key={option.system_covertype_ref} value={option.system_covertype_ref}>{option.name}</option>
                        ))
                      ) : (
                        <option value="" disabled>No covertypes available</option>
                      )}
                </Field>
                <ErrorMessage name="insuranceClass" component="div" className="text-danger small mt-1" />
                </Card>
              )}


                  <Card>
                    <SectionTitle>
                      {values.productType === 'existing' 
                        ? 'Select Product' 
                        : values.productType === 'non-existing' 
                          ? 'Custom Product Name' 
                          : 'Product'}
                    </SectionTitle>

                    {values.productType === 'existing' && (
                      <div className="mb-3">
                        <label className="form-label form-label-sm">Product</label>
                        <Field 
                          as="select" 
                          name="productName" 
                          className="form-control form-control-sm"
                        >
                             <option value="">Select product...</option>
                    {allAvailableProducts?.length > 0 ? (
                        coverProducts?.map(option => (
                          <option key={option.productSystemRef} value={option.productSystemRef} label={option.productName}>
                            {option.productName}
                          </option>
                        ))
                      ) : (
                        <option value="" disabled>No products available</option>
                      )}
                        </Field>
                        <ErrorMessage name="productName" component="div" className="text-danger small mt-1" />
                      </div>
                    )}

                    {values.productType === 'non-existing' && (
                      <div className="mb-3">
                        <label className="form-label form-label-sm">Product Name</label>
                        <Field 
                          name="productName" 
                          type="text" 
                          placeholder="e.g. Custom Private Car Comprehensive 2025"
                          className="form-control form-control-sm"
                        />
                        <ErrorMessage name="productName" component="div" className="text-danger small mt-1" />
                      </div>
                    )}

                    {!values.productType && (
                      <div className="text-muted small py-2">
                        Please select a product type above to continue.
                      </div>
                    )}

                    <div className="d-flex justify-content-end gap-2 mt-4">
                      <button 
                        type="button" 
                        className="btn btn-light" 
                        onClick={onHide}
                      >
                        Cancel
                      </button>
                      <button 
                        type="button" 
                        className="btn btn-primary" 
                        onClick={handleNext}
                        disabled={!values.productType || (values.productType === 'existing' && !values.productName)}
                      >
                        Next
                      </button>
                    </div>
                  </Card>
                </>
              )}

              {/* Step 2: Underwriter & Cover */}
              {currentStep === 1 && (
                <BigGrid>
                  <Card>
                    <SectionTitle>Underwriter & Class</SectionTitle>
                   
                    <div className="mb-2">
                      <label>Underwriter</label>
                      <Field  name="Underwriter" className="form-control form-control-sm">
                      </Field>
                      <ErrorMessage name="Underwriter" component="div" className="text-danger small mt-1" />
                    </div>
                    
                       {values.productType === 'non-existing' && (   
                       <div className="mb-2">
                      <label>Insurance Class</label>
                        <Field
                          as="select"
                          name="insuranceClass"
                          className="form-control form-control-sm"
                          onChange={(e) => {
                            setFieldValue('insuranceClass', e.target.value);
                
                          }}
                        >
                          <option value="">Select Insurance Class...</option>
                          {insuranceClasses.map((cls) => (
                            <option key={cls.id} value={cls.name}>
                              {cls.name}
                            </option>
                          ))}
                        </Field>
                    </div>)}
                  </Card>

                  <Card>
                    <SectionTitle>Cover Period & Type</SectionTitle>
                    <div className="mb-2">
                      <label>Start Date</label>
                      <Field name="startDate" type="date" className="form-control form-control-sm" />
                      <ErrorMessage name="startDate" component="div" className="text-danger small mt-1" />
                    </div>
                    <div className="mb-2">
                      <label>End Date</label>
                      <Field name="endDate" type="date" className="form-control form-control-sm" />
                      <ErrorMessage name="endDate" component="div" className="text-danger small mt-1" />
                    </div>
                    <div className="mb-2">
                      <label>Cover Type</label>
                      <Field as="select" name="CoverType" className="form-control form-control-sm">
                        <option value="">Select cover type</option>
                        {coverTypeOptions.map(o => <option key={o.value} value={o.value}>{o.label}</option>)}
                      </Field>
                      <ErrorMessage name="CoverType" component="div" className="text-danger small mt-1" />
                    </div>
                  </Card>

                  <Card>
                    <SectionTitle>Policy Info</SectionTitle>
                    <div className="mb-2">
                      <label>Policy Number</label>
                      <Field name="policyNumber" className="form-control form-control-sm" />
                      <ErrorMessage name="policyNumber" component="div" className="text-danger small mt-1" />
                    </div>
                  </Card>
                    <div className="d-flex justify-content-end gap-2 mt-3">
                    <button type="button" className="btn btn-light" onClick={() => setCurrentStep(0)}>Back</button>
                    <button type="button" className="btn btn-primary" onClick={handleNext}>Next</button>
                  </div>
                </BigGrid>
                // Add Back/Next buttons similar to your original

              )}

              {/* Step 3: Client Details */}
              {currentStep === 2 && (
                <CardGrid>
                  <Card>
                    <SectionTitle>Client Information</SectionTitle>
                    <FieldRow>
                      <SmallField>
                        <label>First Name</label>
                        <Field name="firstName" className="form-control form-control-sm" />
                        <ErrorMessage name="firstName" component="div" className="text-danger small mt-1" />
                      </SmallField>
                      <SmallField>
                        <label>Middle Name (Optional)</label>
                        <Field name="middleName" className="form-control form-control-sm" />
                      </SmallField>
                      <SmallField>
                        <label>Last Name</label>
                        <Field name="lastName" className="form-control form-control-sm" />
                        <ErrorMessage name="lastName" component="div" className="text-danger small mt-1" />
                      </SmallField>
                    </FieldRow>
                    <FieldRow>
                      <SmallField>
                        <label>Phone</label>
                        <Field name="phone" className="form-control form-control-sm" placeholder="+2547..." />
                        <ErrorMessage name="phone" component="div" className="text-danger small mt-1" />
                      </SmallField>
                      <SmallField>
                        <label>Email</label>
                        <Field name="email" type="email" className="form-control form-control-sm" />
                        <ErrorMessage name="email" component="div" className="text-danger small mt-1" />
                      </SmallField>
                    </FieldRow>
                    <SmallField>
                      <label>KRA PIN</label>
                      <Field name="kraPin" className="form-control form-control-sm" placeholder="A012345678Z" />
                      <ErrorMessage name="kraPin" component="div" className="text-danger small mt-1" />
                    </SmallField>
                  </Card>

                    <div className="d-flex justify-content-end gap-2 mt-3">
                     <button type="button" className="btn btn-light" onClick={() => setCurrentStep(1)}>Back</button>
                    <button type="button" className="btn btn-primary" onClick={handleNext}>Next</button>
                  </div>
                </CardGrid>
                // Back/Next buttons
              )}

              {/* Step 4: Vehicle & Premium */}
              {currentStep === 3 && (
                <>
                  <Card>
                    <SectionTitle>Vehicle (Risk) Details</SectionTitle>
                    <FieldRow>
                      <SmallField>
                        <label>Value (Sum Insured)</label>
                        <Field name="riskValue" type="number" className="form-control form-control-sm" />
                        <ErrorMessage name="riskValue" component="div" className="text-danger small mt-1" />
                      </SmallField>
                      <SmallField>
                        <label>Registration / Ref</label>
                        <Field name="riskRef" className="form-control form-control-sm" placeholder="e.g. KAA 123B" />
                        <ErrorMessage name="riskRef" component="div" className="text-danger small mt-1" />
                      </SmallField>
                      <SmallField>
                        <label>Chassis Number</label>
                        <Field name="riskchassisNumber" className="form-control form-control-sm" />
                        <ErrorMessage name="riskchassisNumber" component="div" className="text-danger small mt-1" />
                      </SmallField>
                      <SmallField>
                        <label>Make</label>
                        <Field name="riskMake" className="form-control form-control-sm" placeholder="e.g. Toyota" />
                        <ErrorMessage name="riskMake" component="div" className="text-danger small mt-1" />
                      </SmallField>
                      <SmallField>
                        <label>Model</label>
                        <Field name="riskModel" className="form-control form-control-sm" placeholder="e.g. Prado" />
                        <ErrorMessage name="riskModel" component="div" className="text-danger small mt-1" />
                      </SmallField>
                    </FieldRow>
                  </Card>

                  <Card>
                    <SectionTitle>Premium Breakdown</SectionTitle>
                    <FieldRow>
                      <SmallField>
                        <label>Base Premium</label>
                        <Field name="basePremium" type="number" className="form-control form-control-sm" />
                        <ErrorMessage name="basePremium" component="div" className="text-danger small mt-1" />
                      </SmallField>
                      <SmallField>
                        <label>Additional Premium</label>
                        <Field name="additionalPremium" type="number" className="form-control form-control-sm" />
                        <ErrorMessage name="additionalPremium" component="div" className="text-danger small mt-1" />
                      </SmallField>
                      <SmallField>
                        <label>Commission Earned</label>
                        <Field name="commisionEarned" type="number" className="form-control form-control-sm" />
                        <ErrorMessage name="commisionEarned" component="div" className="text-danger small mt-1" />
                      </SmallField>
                      <SmallField>
                        <label>Total Discount</label>
                        <Field name="totalDiscount" type="number" className="form-control form-control-sm" />
                        <ErrorMessage name="totalDiscount" component="div" className="text-danger small mt-1" />
                      </SmallField>
                      <SmallField>
                        <label>Currency</label>
                        <Field as="select" name="policyCurrency" className="form-control form-control-sm" disabled>
                          {currencyOptions.map(o => <option key={o.value} value={o.value}>{o.label}</option>)}
                        </Field>
                      </SmallField>
                    </FieldRow>
                    <div className="mt-2">
                      <label>Total Charges</label>
                      <Field name="totalCharges" type="number" className="form-control form-control-sm" />
                    </div>

                  </Card>

                  <div className="d-flex justify-content-between mt-3">
                    <button type="button" className="btn btn-light" onClick={() => setCurrentStep(2)}>Back</button>
                    <div>
                      <button type="button" className="btn btn-light" onClick={onHide} disabled={loading}>Cancel</button>
                      <button type="submit" className="btn btn-success ms-2" disabled={loading}>
                        {loading ? 'Saving...' : 'Save Portfolio'}
                      </button>
                    </div>
                  </div>
                </>
              )}
            </Form>
          );
        }}
      </Formik>
    </Container>
  );
} 